{
  "common.close": "بند کریں",
  "common.athleteFallback": "ایتھلیٹ {id}",
  "splash.title": "{app} — سرگرمیوں کی متحرک تصویر کشی",
  "splash.tagline": "آپ کے&nbsp;Strava ڈیٹا کے لیے متحرک نقشہ",
  "splash.demo": "ڈیمو",
  "tab.query.title": "{name} کا نقشہ",
  "tab.query.heading": "سرگرمیاں تلاش کریں:",
  "tab.query.optDays": "حالیہ دن",
  "tab.query.optActivities": "حالیہ سرگرمیاں",
  "tab.query.optIds": "سرگرمی ID",
  "tab.query.optDates": "تاریخوں کی حد",
  "tab.query.idsPlaceholder": "سرگرمی ID یہاں درج کریں",
  "tab.query.after": "بعد:",
  "tab.query.before": "پہلے:",
  "tab.query.autozoom": "درآمد کے بعد نتائج پر خودکار زوم <i class=\"hf hf-bullseye\"></i> کریں",
  "tab.query.queryButton": "<i class=\"hf hf-cloud-download\"></i> تلاش",
  "tab.query.createAccount": "اکاؤنٹ بنائیں اور/یا لاگ اِن کریں۔",
  "tab.query.sports": "کھیل:",
  "tab.query.allSports": "تمام کھیل",
  "tab.query.sportsExcept": "سب سوائے",
  "tab.query.sportsNone": "کوئی نہیں",
  "tab.query.loadingSports": "کھیل لوڈ ہو رہے ہیں…",
  "tab.query.sportsFailed": "اس نقشے کے کھیل لوڈ نہیں ہو سکے",
  "tab.query.noSports": "ابھی کوئی سرگرمی نہیں",
  "tab.activities.title": "دکھائی گئی سرگرمیاں",
  "tab.activities.clearSelection": "انتخاب ہٹائیں",
  "tab.activities.renderSelected": "منتخب دکھائیں",
  "tab.activities.zoomToSelection": "<i class=\"fas fa-search-plus\"></i> <i class=\"far fa-object-group\"></i> <i class=\"fas fa-search-minus\"></i> انتخاب پر زوم کریں",
  "tab.controls.title": "لیئر کی ترتیبات",
  "tab.controls.timescale": "وقت کا پیمانہ <i>&tau;</i>",
  "tab.controls.timescaleHint": "چلانے کی رفتار",
  "tab.controls.period": "دورانیہ <i>T</i>",
  "tab.controls.periodHint": "سرگرمی ~ ماڈل",
  "tab.controls.dotSize": "نقطے کا سائز",
  "tab.controls.pathWidth": "راستے کی چوڑائی",
  "tab.controls.pathWidthHint": "صفر راستے چھپا دیتا ہے",
  "tab.controls.colors": "رنگ",
  "tab.controls.colorsHint": "رنگوں کی ترتیب گھمائیں",
  "tab.controls.shadows": "سائے",
  "tab.profile.loginTitle": "لاگ اِن",
  "tab.profile.anonNote": "اپنی سرگرمیاں دیکھنے اور اپنا Heatflask اکاؤنٹ سنبھالنے کے لیے Strava سے لاگ اِن کریں۔",
  "tab.profile.loginLink": "Strava سے لاگ اِن کریں",
  "tab.profile.editOnStrava": "Strava پر اپنی پروفائل میں ترمیم کریں",
  "tab.profile.indexNote": "تیز رسائی کے لیے ہم آپ کی سرگرمیوں کے خلاصوں کا اشاریہ رکھتے ہیں۔",
  "tab.profile.viewIndex": "اشاریہ دیکھیں",
  "tab.profile.sharedMaps": "مشترکہ نقشے",
  "tab.profile.sharedMapsNote": "بند: Heatflask پر آپ کی سرگرمیاں صرف آپ دیکھ سکتے ہیں۔ چالو: جس کے پاس بھی آپ کے نقشے کا لنک ہو، وہ وہ سرگرمیاں دیکھ سکتا ہے جو آپ نے Strava پر عوامی کی ہیں۔ آپ کی نجی سرگرمیاں دونوں صورتوں میں آپ ہی کی رہتی ہیں۔ <a id=\"profile-privacy-link\" href=\"#\" target=\"_blank\" rel=\"noopener\">رازداری کیسے کام کرتی ہے</a>",
  "tab.profile.logout": "لاگ آؤٹ",
  "tab.profile.deleteAccount": "اکاؤنٹ حذف کریں",
  "tab.profile.deleteConfirm": "اپنا Heatflask اکاؤنٹ حذف کریں؟\n\nاس سے آپ کی اشاریہ شدہ سرگرمیاں ہٹ جائیں گی اور آپ کے Strava ڈیٹا تک Heatflask کی رسائی منسوخ ہو جائے گی۔ اسے واپس نہیں کیا جا سکتا۔",
  "tab.profile.languageHeading": "زبان",
  "tab.profile.languageAuto": "خودکار",
  "tab.profile.translateNote": "<a id=\"translate-link\" target=\"_blank\" rel=\"noopener\">ترجمے درست کرنے یا نئے شامل کرنے میں ہماری مدد کریں!</a>",
  "tab.profile.unitsHeading": "اکائیاں",
  "tab.profile.unitsAuto": "خودکار",
  "tab.profile.unitsMetric": "میٹرک (کلومیٹر، میٹر)",
  "tab.profile.unitsImperial": "امپیریل (میل، فٹ)",
  "tab.profile.textSizeHeading": "متن کا سائز",
  "tab.profile.textSmaller": "چھوٹا",
  "tab.profile.textReset": "عام",
  "tab.profile.textLarger": "بڑا",
  "tab.profile.mapDefaultsHeading": "نقشے کی طے شدہ ترتیبات",
  "tab.profile.mapDefaultsNote": "جب بھی ایسا نقشہ کھولیں جس کا لنک اپنی ترتیبات طے نہیں کرتا، اسی بنیادی نقشے، زمینی خدوخال اور لیئر کی ترتیبات سے شروع کریں۔ آپ کے شیئر کیے ہوئے لنک پھر بھی بالکل وہی دکھاتے ہیں جو آپ دیکھتے ہیں۔",
  "tab.profile.mapDefaultsSave": "میری طے شدہ کے طور پر محفوظ کریں",
  "tab.profile.mapDefaultsForget": "بھول جائیں",
  "tab.info.title": "معلومات",
  "tab.info.controlsHeading": "کنٹرول",
  "tab.info.shiftDragKey": "<kbd>Shift</kbd> + گھسیٹیں",
  "tab.info.shiftDragDesc": "ایک خانے میں سرگرمیاں منتخب کریں۔ ٹچ اسکرین پر پہلے <i class=\"hf-object-group\"></i> دبائیں، پھر ایک انگلی سے گھسیٹیں۔ آخری منتخب سرگرمی اپنی تفصیل دکھاتی ہے، اور سرگرمیوں کی فہرست اس تک اسکرول ہو جاتی ہے۔",
  "tab.info.ctrlDragKey": "<kbd>Ctrl</kbd> + گھسیٹیں",
  "tab.info.ctrlDragDesc": "نقشے کو 3D میں گھمائیں اور جھکائیں، یا دو انگلیاں استعمال کریں",
  "tab.info.spaceKey": "<kbd>Space</kbd>",
  "tab.info.spaceDesc": "سائیڈبار کھولیں یا بند کریں",
  "tab.info.arrowsKey": "<kbd>&uarr;</kbd> <kbd>&darr;</kbd>",
  "tab.info.arrowsDesc": "پچھلا یا اگلا سائیڈبار ٹیب",
  "tab.info.escKey": "<kbd>Esc</kbd>",
  "tab.info.escDesc": "سائیڈبار بند کریں",
  "tab.info.liveUrlHeading": "لائیو URL",
  "tab.info.liveUrlDesc": "نقشے کا منظر اور حرکت کی ترتیبات صفحے کے URL میں رکھی جاتی ہیں، اس لیے آپ جس کے ساتھ بھی اسے شیئر کریں وہ وہی منظر دیکھتا ہے۔",
  "tab.info.videoHeading": "ویڈیو برآمد",
  "tab.info.videoDesc": "<i class=\"hf-video-camera\"></i> بٹن حرکت کو MP4 کے طور پر ریکارڈ کرتا ہے: اسے دبائیں، خانے کو نقشے کے مطلوبہ حصے پر رکھیں، اور ریکارڈ کرنے کے لیے دوبارہ دبائیں۔ حرکت کا ایک پورا چکر ریکارڈ ہوتا ہے، اس لیے ویڈیو بغیر رکاوٹ دہرائی جاتی ہے؛ {max} سیکنڈ (Strava جتنی لمبی ویڈیو قبول کرتا ہے) سے لمبا چکر {max} پر کاٹ دیا جاتا ہے۔",
  "tab.info.contributeHeading": "تعاون کریں",
  "tab.info.sponsor": "<i class=\"hf-github\"></i> GitHub پر سرپرستی کریں",
  "tab.info.contactsHeading": "رابطے",
  "map.basemapAndTerrain": "بنیادی نقشہ اور زمینی خدوخال",
  "map.pauseAnimation": "حرکت روکیں",
  "map.resumeAnimation": "حرکت جاری رکھیں",
  "capture.record": "ویڈیو ریکارڈ کریں ({period} سیکنڈ کا چکر)",
  "capture.recordTruncated": "ویڈیو ریکارڈ کریں (ایک چکر {period} سیکنڈ کا ہے؛ صرف پہلے {max} سیکنڈ ریکارڈ ہوں گے)",
  "capture.recordArea": "خانے کے اندر کا حصہ ریکارڈ کریں",
  "capture.stop": "ریکارڈنگ روکیں",
  "capture.selectionTooSmall": "انتخاب بہت چھوٹا ہے",
  "capture.saved": "{name} محفوظ ہو گیا ({size})",
  "capture.cancelled": "ریکارڈنگ منسوخ",
  "capture.failed": "ریکارڈنگ ناکام: {error}",
  "capture.loadingEncoder": "انکوڈر لوڈ ہو رہا ہے…",
  "capture.waitingForMap": "نقشہ لوڈ ہونے کا انتظار…",
  "capture.encoding": "انکوڈ ہو رہا ہے… {percent}%",
  "capture.finalizing": "مکمل کیا جا رہا ہے…",
  "share.title": "اس نقشے کا لنک شیئر کریں",
  "share.copied": "لنک کاپی ہو گیا",
  "share.copiedUnshared": "لنک کاپی ہو گیا، لیکن آپ کا نقشہ شیئر نہیں ہے، اس لیے کوئی اور اسے نہیں کھول سکتا۔ اسے بدلنے کے لیے «مشترکہ نقشے» آن کریں۔",
  "share.unshared": "آپ کا نقشہ شیئر نہیں ہے، اس لیے کوئی اور یہ لنک نہیں کھول سکتا۔ اسے بدلنے کے لیے «مشترکہ نقشے» آن کریں۔",
  "share.copyThis": "یہ لنک کاپی کریں:",
  "update.available": "Heatflask کا نیا ورژن دستیاب ہے۔",
  "update.reload": "دوبارہ لوڈ کریں",
  "import.title": "درآمد ہو رہا ہے",
  "import.stop": "روکیں",
  "import.stopping": "رک رہا ہے…",
  "import.contacting": "Strava سے رابطہ ہو رہا ہے…",
  "import.countOf": "سرگرمیاں: {total} میں سے {received}",
  "import.count": "سرگرمیاں: {received}",
  "import.waitStrava": "Strava کی ڈاؤن لوڈ حد کی وجہ سے {time} تک رکا ہوا ہے۔ یہ صفحہ کھلا رہنے دیں؛ دوبارہ لوڈ کرنے سے رفتار نہیں بڑھے گی۔",
  "import.waitRationed": "آج کے تیز ڈاؤن لوڈ ختم ہو گئے۔ باقی {time} پر آہستہ جاری رہیں گے۔ یہ صفحہ کھلا رہنے دیں۔",
  "import.dailyLimit": "Strava کی روزانہ ڈاؤن لوڈ حد پوری ہو گئی۔ {time} کے بعد دوبارہ کوشش کریں۔",
  "import.dailyRationed": "آج کے لیے Strava ڈاؤن لوڈز میں آپ کا حصہ ختم ہو گیا۔ {time} کے بعد دوبارہ کوشش کریں۔",
  "import.noActivitiesYet": "آپ کے Strava اکاؤنٹ میں ابھی کوئی سرگرمی نہیں ہے۔ Strava پر ایک ریکارڈ یا اپ لوڈ کریں، وہ یہاں نظر آئے گی۔",
  "table.noActivities": "کوئی سرگرمی نہیں",
  "table.untitled": "(بلا عنوان)",
  "activities.pageTitle": "{app} — سرگرمیوں کا اشاریہ",
  "activities.heading": "سرگرمیوں کا اشاریہ",
  "activities.fetching": "سرگرمیاں لائی جا رہی ہیں...",
  "activities.rateLimit": "Strava کی درخواستوں کی حد پوری ہو گئی؛ {time} پر دوبارہ شروع ہوگا",
  "activities.noData": "معذرت، کوئی ڈیٹا نہیں &#128577;",
  "activities.colServerCache": "ٹریک سرور پر محفوظ (Mongo)",
  "activities.colBrowserCache": "ٹریک اس براؤزر میں محفوظ",
  "activities.cachedServer": "{id} کا ٹریک سرور پر محفوظ ہے",
  "activities.notCachedServer": "{id} کا ٹریک سرور پر محفوظ نہیں",
  "activities.cachedBrowser": "{id} کا ٹریک اس براؤزر میں محفوظ ہے",
  "activities.notCachedBrowser": "{id} کا ٹریک اس براؤزر میں محفوظ نہیں",
  "sport.AlpineSki": "الپائن اسکیئنگ",
  "sport.BackcountrySki": "بیک کنٹری اسکیئنگ",
  "sport.Badminton": "بیڈمنٹن",
  "sport.Basketball": "باسکٹ بال",
  "sport.Canoeing": "کینو رانی",
  "sport.Cricket": "کرکٹ",
  "sport.Crossfit": "کراس فٹ",
  "sport.Dance": "رقص",
  "sport.EBikeRide": "ای بائیک سواری",
  "sport.Elliptical": "ایلپٹیکل",
  "sport.EMountainBikeRide": "ای ماؤنٹین بائیک سواری",
  "sport.Golf": "گالف",
  "sport.GravelRide": "گریول سواری",
  "sport.Handcycle": "ہینڈ سائیکل",
  "sport.HighIntensityIntervalTraining": "ہائی انٹینسٹی انٹرول ٹریننگ",
  "sport.Hike": "پیدل سفر",
  "sport.IceSkate": "آئس اسکیٹنگ",
  "sport.InlineSkate": "ان لائن اسکیٹنگ",
  "sport.Kayaking": "کیاکنگ",
  "sport.Kitesurf": "کائٹ سرفنگ",
  "sport.MountainBikeRide": "ماؤنٹین بائیک سواری",
  "sport.NordicSki": "نارڈک اسکیئنگ",
  "sport.Padel": "پیڈل",
  "sport.PhysicalTherapy": "فزیوتھراپی",
  "sport.Pickleball": "پکل بال",
  "sport.Pilates": "پیلاٹیز",
  "sport.Racquetball": "ریکٹ بال",
  "sport.Ride": "سائیکل سواری",
  "sport.RockClimbing": "چٹان پیمائی",
  "sport.RollerSki": "رولر اسکی",
  "sport.Rowing": "کشتی رانی",
  "sport.Run": "دوڑ",
  "sport.Sail": "بادبانی کشتی رانی",
  "sport.Skateboard": "اسکیٹ بورڈ",
  "sport.Snowboard": "اسنو بورڈ",
  "sport.Snowshoe": "برفانی جوتوں سے چلنا",
  "sport.Soccer": "فٹ بال",
  "sport.Squash": "اسکواش",
  "sport.StairStepper": "سیڑھی مشین",
  "sport.StandUpPaddling": "کھڑے ہو کر پیڈلنگ",
  "sport.Surfing": "سرفنگ",
  "sport.Swim": "تیراکی",
  "sport.TableTennis": "ٹیبل ٹینس",
  "sport.Tennis": "ٹینس",
  "sport.TrailRun": "ٹریل رن",
  "sport.Velomobile": "ویلو موبائل",
  "sport.VirtualRide": "ورچوئل سائیکل سواری",
  "sport.VirtualRow": "ورچوئل کشتی رانی",
  "sport.VirtualRun": "ورچوئل دوڑ",
  "sport.Volleyball": "والی بال",
  "sport.Walk": "چہل قدمی",
  "sport.WeightTraining": "ویٹ ٹریننگ",
  "sport.Wheelchair": "وہیل چیئر",
  "sport.Windsurf": "ونڈ سرفنگ",
  "sport.Workout": "ورزش",
  "sport.Yoga": "یوگا"
}
